// // // import React from 'react';
// // import Breadcrumb from '@components/Shared/Breadcrumb';
// // import { Card, CardBody } from '@components/card/card';
// // import { useTranslation } from 'react-i18next';
// // import { Link } from 'react-router-dom';
// // import Loading from '@components/Shared/Loader/Loading';
// // import useGetPaymentsList from '@hooks/Finance/ApPayments/useGetPaymentsList';
// // import NtxTable from '@components/DataTable/NtxTable';
// // import { paymentTypeEnum } from './paymentTypeEnum';

// // const Index = () => {
// //   const { t, i18n } = useTranslation();

// //   const { ApPaymentsList: data, loading, error } = useGetPaymentsList();

// //   // دالة لتنسيق المبلغ
// //   const formatAmount = (amount: number) => {
// //     return new Intl.NumberFormat(i18n.language, {
// //       minimumFractionDigits: 2,
// //       maximumFractionDigits: 2
// //     }).format(amount);
// //   };

// //   const getPaymentTypeDisplay = (type: string, name: string) => {
// //     switch (type) {
// //       case paymentTypeEnum.Standard: // قياسي
// //         return (
// //           <span className='badge bg-primary'>
// //             <i className='fas fa-file-invoice-dollar me-1'></i>
// //             {name}
// //           </span>
// //         );

// //       case paymentTypeEnum.PrePayment: // دفعة مقدمة
// //         return (
// //           <span className='badge bg-success'>
// //             <i className='fas fa-hand-holding-usd me-1'></i>
// //             {name}
// //           </span>
// //         );

// //       case paymentTypeEnum.Refund: // استرداد
// //         return (
// //           <span className='badge bg-danger'>
// //             <i className='fas fa-rotate-left me-1'></i>
// //             {name}
// //           </span>
// //         );

// //       case paymentTypeEnum.ApplyPrePayment: // تطبيق دفعة مقدمة
// //         return (
// //           <span className='badge bg-info text-dark'>
// //             <i className='fas fa-link me-1'></i>
// //             {name}
// //           </span>
// //         );

// //       case paymentTypeEnum.ApplyDebitMemo: // تطبيق إشعار مدين
// //         return (
// //           <span className='badge bg-warning text-dark'>
// //             <i className='fas fa-file-invoice me-1'></i>
// //             {/* {name} */}
// //             تطبيق إشعار مدين
// //           </span>
// //         );

// //       default:
// //         return (
// //           <span className='badge bg-secondary'>
// //             <i className='fas fa-question-circle me-1'></i>
// //             {name}
// //           </span>
// //         );
// //     }
// //   };

// //   // دالة جديدة لعرض شارة الحالة
// //   const getStatusBadge = (status: string) => {
// //     switch (status?.toLowerCase()) {
// //       case 'active':
// //         return (
// //           <span className='badge bg-success'>
// //             <i className='fas fa-check-circle me-1'></i>
// //             {t('مكتمل')}
// //           </span>
// //         );
// //       case 'cancelled':
// //         return (
// //           <span className='badge bg-danger'>
// //             <i className='fas fa-times-circle me-1'></i>
// //             {t('ملغي')}
// //           </span>
// //         );
// //       case 'posted':
// //         return (
// //           <span className='badge bg-primary'>
// //             <i className='fas fa-paper-plane me-1'></i>
// //             {t('Posted')}
// //           </span>
// //         );
// //       case 'draft':
// //         return (
// //           <span className='badge bg-secondary'>
// //             <i className='fas fa-edit me-1'></i>
// //             {t('Draft')}
// //           </span>
// //         );
// //       case 'pending':
// //         return (
// //           <span className='badge bg-warning text-dark'>
// //             <i className='fas fa-clock me-1'></i>
// //             {t('Pending')}
// //           </span>
// //         );
// //       default:
// //         return (
// //           <span className='badge bg-light text-dark'>
// //             <i className='fas fa-circle me-1'></i>
// //             {status || t('Unknown')}
// //           </span>
// //         );
// //     }
// //   };

// //   // دالة جديدة لتنسيق رقم السند بناءً على الحالة
// //   const formatVoucherNumber = (code: string, status: string) => {
// //     const isCancelled = status?.toLowerCase() === 'cancelled';

// //     if (isCancelled) {
// //       return (
// //         <span className='text-danger text-decoration-line-through fw-bold' style={{ letterSpacing: '0.09em' }}>
// //           {code}
// //         </span>
// //       );
// //     }

// //     return (
// //       <span className='  fw-bold' style={{ letterSpacing: '0.09em' }}>
// //         {' '}
// //         {code}
// //       </span>
// //     );
// //   };

// //   const renderDescription = (text?: string | null) => {
// //     const v = (text ?? '').trim();
// //     if (!v) return <span className='text-muted'>-</span>;

// //     const max = 60;
// //     if (v.length <= max) return <span>{v}</span>;

// //     return <span title={v}>{v.slice(0, max)}…</span>;
// //   };

// //   const columns = [
// //     { title: t('VoucherNumber'), key: 'code' },
// //     { title: t('Date'), key: 'paymentDate' },
// //     { title: t('PaymentType'), key: 'Type' },
// //     // ✅ جديد
// //     { title: t('Description'), key: 'description' },

// //     { title: t('Amount'), key: 'amount', className: 'text-theme' },
// //     { title: t('Supplier'), key: 'peopleName' },
// //     { title: t('وحدة التشغيل'), key: 'organizationName' },
// //     { title: t('status'), key: 'status' },
// //     {
// //       title: t('PostingStatus'),
// //       key: 'postedFlagDisplay',
// //       className: 'text-center',
// //       sortValue: (row: any) => (row.postedFlag ? 1 : 0) // قيمة رقمية للفرز
// //     },
// //     { title: '', key: 'action', className: 'text-end' }
// //   ];

// //   const makePaymentCodeSortKey = (code?: string | null) => {
// //     if (!code) return 0;

// //     const v = String(code).trim();

// //     // AP202628 => Prefix + YYYY + Seq
// //     const m = v.match(/^([A-Za-z]+)(\d{4})(\d+)$/);
// //     if (m) {
// //       const year = Number(m[2]); // 2026
// //       const seq = Number(m[3]); // 28
// //       return year * 1_000_000_000 + seq;
// //     }

// //     // fallback
// //     const digits = (v.match(/\d+/g) || []).join('');
// //     return digits ? Number(digits) : 0;
// //   };

// //   const tableData = data
// //     .slice()
// //     .sort((a, b) => makePaymentCodeSortKey(b.code) - makePaymentCodeSortKey(a.code))
// //     .map(item => {
// //       const postedFlagBadge = item.postedFlag ? (
// //         <span className='badge bg-success'>
// //           <i className='fas fa-check me-1'></i>
// //           {t('Posted')}
// //         </span>
// //       ) : (
// //         <span className='badge bg-danger'>
// //           <i className='fas fa-times me-1'></i>
// //           {t('NotPosted')}
// //         </span>
// //       );

// //       const TypeName = i18n.language === 'en' ? item.paymentTypeName : item.paymentTypeName2;

// //       const desc = item.description;

// //       return {
// //         code: formatVoucherNumber(item.code, item.status),
// //         // code: item.code,
// //         paymentDate: item.paymentDate.split('T')[0],
// //         Type: getPaymentTypeDisplay(item.paymentType, TypeName), // 👈 صار Badge + أيقونة

// //         // ✅ جديد
// //         description: renderDescription(desc),

// //         amount: <span className='fw-bold text-theme'>{formatAmount(item.amount)}</span>,

// //         peopleName: i18n.language === 'en' ? item.peopleName : item.peopleName2,
// //         organizationName: i18n.language === 'en' ? item.organizationName : item.organizationName2,
// //         // status: item.status,
// //         status: getStatusBadge(item.status), // 👈 استخدام الدالة الجديدة

// //         postedFlag: item.postedFlag,
// //         postedFlagDisplay: postedFlagBadge,
// //         action: (
// //           <Link to={`${item.id}/UpdateApPayments`} className='btn btn-sm btn-outline-theme mx-1'>
// //             <i className='fas fa-info-circle fa-lg'></i>
// //           </Link>
// //         )
// //       };
// //     });

// //   return (
// //     <div>
// //       <div className='d-flex align-items-center'>
// //         <Breadcrumb
// //           BreadcrumbList={[
// //             {
// //               name: 'Home',
// //               link: ':moduleHome'
// //             },
// //             {
// //               name: 'Payments',
// //               link: null
// //             }
// //           ]}
// //           PageName='Payments'
// //         />
// //         <div className='ms-auto'>
// //           <Link to='AddApPayments' className='btn me-1 btn-theme'>
// //             <i className='fa fa-plus-circle fa-fw me-1'></i>
// //             {t('NewPayment')}
// //           </Link>
// //         </div>
// //       </div>
// //       <Card>
// //         <Loading loading={loading} error={error}>
// //           <CardBody>
// //             <NtxTable
// //               data={tableData || []}
// //               columns={columns}
// //               dataPerPage={10}
// //               theadClass=''
// //               tableClass='table text-nowrap table-hover'
// //               enableSearch={true}
// //               showRecordsSelector={true}
// //             />
// //           </CardBody>
// //         </Loading>
// //       </Card>
// //     </div>
// //   );
// // };

// // export default Index;

// import { useEffect, useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { Card, CardFooter, CardHeader } from '@components/card/card';
// import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';
// import Loading from '@components/Shared/Loader/Loading';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { getPagedData, setEndpoint, setFilters } from '@store/DynamicFilter/dynamicTableSlice';
// import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
// import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';
// import Select from 'react-select';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
// import { paymentTypeEnum } from './paymentTypeEnum';

// const TABLE_KEY = 'ApPayments_Index';

// const Index = () => {
//   const { t, i18n } = useTranslation();

//   // ✅ حالة الفلاتر المحلية
//   const [supplierFilter, setSupplierFilter] = useState<any>(null);
//   const [organizationFilter, setOrganizationFilter] = useState<any>(null);
//   const [dateFrom, setDateFrom] = useState('');
//   const [dateTo, setDateTo] = useState('');
//   const [statusFilter, setStatusFilter] = useState<any>(null);
//   const [paymentTypeFilter, setPaymentTypeFilter] = useState<any>(null);
//   const [showFilters, setShowFilters] = useState(false);

//   const { OperatingUnitOptions } = useGetOperatingUnitWithPermission();
//   const { OptionSuppliers } = useGetSuppliersList();

//   const dispatch = useAppDispatch();
//   const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
//   const data = tableState?.data ?? [];
//   const loading = tableState?.loading ?? false;
//   const error = tableState?.error ?? null;
//   const filters = tableState?.filters ?? [];
//   const [activeFiltersCount, setActiveFiltersCount] = useState(0);

//   // ✅ تهيئة الجدول
//   useEffect(() => {
//     dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'Ap/GetApPaymentsList_Paged' }));
//     dispatch(getPagedData({ tableKey: TABLE_KEY }));
//   }, [dispatch]);

//   // ✅ حساب عدد الفلاتر النشطة
//   useEffect(() => {
//     setActiveFiltersCount(filters.length);
//   }, [filters]);

//   // ✅ دالة إنشاء ID فريد للفلتر
//   const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

//   // ✅ دالة تطبيق الفلاتر
//   const applyFilters = () => {
//     const newFilters: any[] = [];

//     if (supplierFilter) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'peopleId',
//         operator: 0,
//         value: supplierFilter.value
//       });
//     }

//     if (organizationFilter) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'organizationId',
//         operator: 0,
//         value: organizationFilter.value
//       });
//     }

//     if (statusFilter) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'status',
//         operator: 0,
//         value: statusFilter.value
//       });
//     }

//     if (paymentTypeFilter) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'paymentType',
//         operator: 0,
//         value: paymentTypeFilter.value
//       });
//     }

//     if (dateFrom) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'paymentDate',
//         operator: 3,
//         value: dateFrom
//       });
//     }

//     if (dateTo) {
//       newFilters.push({
//         id: generateFilterId(),
//         field: 'paymentDate',
//         operator: 5,
//         value: dateTo
//       });
//     }

//     dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
//     dispatch(getPagedData({ tableKey: TABLE_KEY }));
//   };

//   // ✅ دالة مسح جميع الفلاتر
//   const clearFilters = (): void => {
//     setSupplierFilter(null);
//     setOrganizationFilter(null);
//     setStatusFilter(null);
//     setPaymentTypeFilter(null);
//     setDateFrom('');
//     setDateTo('');

//     dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
//     dispatch(getPagedData({ tableKey: TABLE_KEY }));
//   };

//   // ✅ خيارات حالة السند
//   const statusOptions = [
//     { value: 'active', label: t('مكتمل') },
//     { value: 'cancelled', label: t('ملغي') },
//     { value: 'posted', label: t('Posted') },
//     { value: 'draft', label: t('Draft') },
//     { value: 'pending', label: t('Pending') }
//   ];

//   // ✅ خيارات نوع السند
//   const paymentTypeOptions = [
//     { value: paymentTypeEnum.Standard, label: t('Standard') },
//     { value: paymentTypeEnum.PrePayment, label: t('PrePayment') },
//     { value: paymentTypeEnum.Refund, label: t('Refund') },
//     { value: paymentTypeEnum.ApplyPrePayment, label: t('ApplyPrePayment') },
//     { value: paymentTypeEnum.ApplyDebitMemo, label: t('ApplyDebitMemo') }
//   ];

//   // ✅ حقول Dynamic Filter
//   const fields: any = [
//     { name: 'code', label: t('VoucherNumber'), type: 'string' },
//     { name: 'paymentDate', label: t('Date'), type: 'date' },
//     {
//       name: 'paymentType',
//       label: t('PaymentType'),
//       type: 'options',
//       options: paymentTypeOptions
//     },
//     {
//       name: 'status',
//       label: t('status'),
//       type: 'options',
//       options: statusOptions
//     },
//     {
//       name: 'postedFlag',
//       label: t('PostingStatus'),
//       type: 'options',
//       options: [
//         { value: true, label: t('Posted') },
//         { value: false, label: t('NotPosted') }
//       ]
//     },
//     { name: 'peopleId', label: t('Supplier'), type: 'options', options: OptionSuppliers },
//     { name: 'organizationId', label: t('OperatingUnit'), type: 'options', options: OperatingUnitOptions },
//     { name: 'description', label: t('Description'), type: 'string' },
//     { name: 'amount', label: t('Amount'), type: 'number' }
//   ];

//   // ✅ دالة لتنسيق المبلغ
//   const formatAmount = (amount: number) => {
//     return new Intl.NumberFormat(i18n.language, {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(amount);
//   };

//   // ✅ دالة لعرض نوع السند مع أيقونة
//   const getPaymentTypeDisplay = (type: string, name: string) => {
//     switch (type) {
//       case paymentTypeEnum.Standard:
//         return (
//           <span className='badge bg-primary' title={name}>
//             <i className='fas fa-file-invoice-dollar me-1'></i>
//             قياسي
//           </span>
//         );
//       case paymentTypeEnum.PrePayment:
//         return (
//           <span className='badge bg-success' title={name}>
//             <i className='fas fa-hand-holding-usd me-1'></i>
//             مقدمة
//           </span>
//         );
//       case paymentTypeEnum.Refund:
//         return (
//           <span className='badge bg-danger' title={name}>
//             <i className='fas fa-rotate-left me-1'></i>
//             استرداد
//           </span>
//         );
//       case paymentTypeEnum.ApplyPrePayment:
//         return (
//           <span className='badge bg-info text-dark' title={name}>
//             <i className='fas fa-link me-1'></i>
//             تطبيق مقدمة
//           </span>
//         );
//       case paymentTypeEnum.ApplyDebitMemo:
//         return (
//           <span className='badge bg-warning text-dark' title="تطبيق إشعار مدين">
//             <i className='fas fa-file-invoice me-1'></i>
//             تطبيق مدين
//           </span>
//         );
//       default:
//         return (
//           <span className='badge bg-secondary' title={name}>
//             <i className='fas fa-question-circle me-1'></i>
//             {name}
//           </span>
//         );
//     }
//   };

//   // ✅ دالة لعرض الحالة مع أيقونة
//   const getStatusBadge = (status: string) => {
//     switch (status?.toLowerCase()) {
//       case 'active':
//         return (
//           <span className='badge bg-success' title={t('مكتمل')}>
//             <i className='fas fa-check-circle me-1'></i>
//             مكتمل
//           </span>
//         );
//       case 'cancelled':
//         return (
//           <span className='badge bg-danger' title={t('ملغي')}>
//             <i className='fas fa-times-circle me-1'></i>
//             ملغي
//           </span>
//         );
//       case 'posted':
//         return (
//           <span className='badge bg-primary' title={t('Posted')}>
//             <i className='fas fa-paper-plane me-1'></i>
//             مرفوع
//           </span>
//         );
//       case 'draft':
//         return (
//           <span className='badge bg-secondary' title={t('Draft')}>
//             <i className='fas fa-edit me-1'></i>
//             مسودة
//           </span>
//         );
//       case 'pending':
//         return (
//           <span className='badge bg-warning text-dark' title={t('Pending')}>
//             <i className='fas fa-clock me-1'></i>
//             معلق
//           </span>
//         );
//       default:
//         return (
//           <span className='badge bg-light text-dark' title={status || t('Unknown')}>
//             <i className='fas fa-circle me-1'></i>
//             {status || 'غير معروف'}
//           </span>
//         );
//     }
//   };

//   // ✅ دالة لعرض حالة الترحيل
//   const getPostedFlagBadge = (flag: boolean) =>
//     flag ? (
//       <span className='badge bg-success' title={t('Posted')}>
//         <i className='fas fa-check me-1'></i>
//         مرفوع
//       </span>
//     ) : (
//       <span className='badge bg-danger' title={t('NotPosted')}>
//         <i className='fas fa-times me-1'></i>
//         غير مرفوع
//       </span>
//     );

//   // ✅ دالة لعرض رقم السند مع تاريخه في عمود واحد
//   const renderVoucherWithDate = (code: string, date: string, status: string) => {
//     const formattedDate = date.split('T')[0];
//     const isCancelled = status?.toLowerCase() === 'cancelled';

//     return (
//       <div className='d-flex flex-column'>
//         <div className='fw-bold'>
//           {isCancelled ? (
//             <span className='text-danger text-decoration-line-through' style={{ letterSpacing: '0.05em' }}>
//               {code}
//             </span>
//           ) : (
//             <span className='text-theme' style={{ letterSpacing: '0.05em' }}>
//               {code}
//             </span>
//           )}
//         </div>
//         <small className='text-muted'>
//           <i className='fas fa-calendar-alt me-1'></i>
//           {formattedDate}
//         </small>
//       </div>
//     );
//   };

//   // ✅ دالة لعرض المورد مع وحدة التشغيل في عمود واحد
//   const renderSupplierWithOrg = (supplierName: string, orgName: string, supplierCode?: string) => {
//     return (
//       <div className='d-flex flex-column'>
//         <div className='fw-bold'>{supplierName}</div>
//         {supplierCode && (
//           <small className='text-muted'>
//             <i className='fas fa-hashtag me-1'></i>
//             {supplierCode}
//           </small>
//         )}
//         <small className='text-muted mt-1'>
//           <i className='fas fa-building me-1'></i>
//           {orgName}
//         </small>
//       </div>
//     );
//   };

//   // ✅ دالة لعرض الحالة مع الترحيل في عمود واحد
//   const renderStatusWithPosting = (status: string, postedFlag: boolean) => {
//     return (
//       <div className='d-flex flex-column align-items-center gap-1'>
//         {getStatusBadge(status)}
//         {getPostedFlagBadge(postedFlag)}
//       </div>
//     );
//   };

//   // ✅ دالة لعرض المبلغ مع الوصف في عمود واحد
//   const renderAmountWithDescription = (amount: number, description?: string) => {
//     const desc = (description ?? '').trim();

//     return (
//       <div className='d-flex flex-column'>
//         <span className='fw-bold text-theme fs-6'>{formatAmount(amount)}</span>
//         {desc && (
//           <small className='text-muted mt-1' title={desc}>
//             <i className='fas fa-align-left me-1'></i>
//             {desc.length > 40 ? `${desc.substring(0, 40)}...` : desc}
//           </small>
//         )}
//       </div>
//     );
//   };

//   const breadcrumbList = [
//     { name: t('Home'), link: ':moduleHome' },
//     { name: t('Payments'), link: null }
//   ];

//   return (
//     <>
//       <div className='d-flex flex-wrap align-items-center gap-2'>
//         <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('Payments')} />
//         <div className='ms-auto'>
//           <Link to='AddApPayments' className='btn btn-theme'>
//             <i className='fa fa-plus-circle fa-fw me-1'></i>
//             {t('NewPayment')}
//           </Link>
//         </div>
//       </div>

//       <Card className='mb-4'>
//         <CardHeader>
//           <div className='row g-2'>
//             {/* ✅ فلترة بوحدة التشغيل */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-building'></i>
//                 </span>
//                 <Select
//                   value={organizationFilter}
//                   onChange={setOrganizationFilter}
//                   options={OperatingUnitOptions}
//                   placeholder={t('اختر وحدة تشغيـل')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                 />
//               </div>
//             </div>

//             {/* ✅ فلترة بالمورد */}
//             <div className='col-lg-3'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-truck'></i>
//                 </span>
//                 <Select
//                   value={supplierFilter}
//                   onChange={setSupplierFilter}
//                   options={OptionSuppliers}
//                   placeholder={t('اختر مورد')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                 />
//               </div>
//             </div>

//             {/* ✅ فلترة بنوع السند */}
//             <div className='col-lg-2'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-file-invoice-dollar'></i>
//                 </span>
//                 <Select
//                   value={paymentTypeFilter}
//                   onChange={setPaymentTypeFilter}
//                   options={paymentTypeOptions}
//                   placeholder={t('نوع السند')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                 />
//               </div>
//             </div>

//             {/* ✅ فلترة بالحالة */}
//             <div className='col-lg-2'>
//               <div className='input-group'>
//                 <span className='input-group-text fw-bold'>
//                   <i className='fas fa-info-circle'></i>
//                 </span>
//                 <Select
//                   value={statusFilter}
//                   onChange={setStatusFilter}
//                   options={statusOptions}
//                   placeholder={t('الحالة')}
//                   isClearable
//                   isSearchable
//                   className='flex-grow-1'
//                   classNamePrefix='react-select'
//                 />
//               </div>
//             </div>

//             {/* ✅ التاريخ من وإلى */}
//             <div className='col-lg-4'>
//               <div className='input-group'>
//                 <span className='input-group-text'>
//                   <i className='fas fa-calendar-alt text-muted'></i>
//                 </span>
//                 <input
//                   type='date'
//                   className='form-control border-start-0'
//                   value={dateFrom}
//                   onChange={e => setDateFrom(e.target.value)}
//                   placeholder={t('من')}
//                 />
//                 <span className='input-group-text'>-</span>
//                 <input
//                   type='date'
//                   className='form-control'
//                   value={dateTo}
//                   onChange={e => setDateTo(e.target.value)}
//                   placeholder={t('إلى')}
//                 />
//               </div>
//             </div>

//             {/* ✅ أزرار التطبيق والمسح */}
//             <div className='col-lg-2 text-end'>
//               <button
//                 className='btn btn-outline-secondary me-2'
//                 type='button'
//                 onClick={clearFilters}
//                 title={t('ClearFilters')}
//                 disabled={activeFiltersCount === 0}
//               >
//                 <i className='fas fa-times fa-fw'></i>
//               </button>
//               <button
//                 className='btn btn-theme me-2'
//                 type='button'
//                 onClick={applyFilters}
//                 title={t('ApplyFilters')}
//                 disabled={!supplierFilter && !organizationFilter && !paymentTypeFilter && !statusFilter && !dateFrom && !dateTo}
//               >
//                 <i className='fas fa-filter fa-fw'></i>
//               </button>
//               <button
//                 className='btn btn-outline-theme'
//                 onClick={() => setShowFilters(true)}
//                 title={t('SearchFilters')}
//               >
//                 <i className='fas fa-sliders-h fa-fw'></i>
//               </button>
//             </div>
//           </div>
//         </CardHeader>

//         <Loading loading={loading} error={error}>
//           <div className='table-responsive'>
//             <table className='table table-hover mb-0'>
//               <thead className='bg-theme bg-opacity-25 fw-bold'>
//                 <tr>
//                   <th className='small'>رقم السند / التاريخ</th>
//                   <th className='small'>نوع السند</th>
//                   <th className='small'>المبلغ / الوصف</th>
//                   <th className='small'>المورد / وحدة التشغيل</th>
//                   <th className='small text-center'>الحالة / الترحيل</th>
//                   <th className='small text-center'>الإجراءات</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {data.length > 0 ? (
//                   data.map((item: any) => {
//                     const TypeName = i18n.language === 'en' ? item.paymentTypeName : item.paymentTypeName2;
//                     const supplierName = i18n.language === 'en' ? item.peopleName : item.peopleName2;
//                     const orgName = i18n.language === 'en' ? item.organizationName : item.organizationName2;

//                     return (
//                       <tr key={item.id}>
//                         <td className='align-middle'>
//                           {renderVoucherWithDate(item.code, item.paymentDate, item.status)}
//                         </td>
//                         <td className='align-middle'>
//                           {getPaymentTypeDisplay(item.paymentType, TypeName)}
//                         </td>
//                         <td className='align-middle'>
//                           {renderAmountWithDescription(item.amount, item.description)}
//                         </td>
//                         <td className='align-middle'>
//                           {renderSupplierWithOrg(supplierName, orgName, item.peopleCode)}
//                         </td>
//                         <td className='align-middle text-center'>
//                           {renderStatusWithPosting(item.status, item.postedFlag || false)}
//                         </td>
//                         <td className='align-middle text-end'>
//                           <div className='d-flex justify-content-end gap-2'>
//                             <Link
//                               to={`${item.id}/UpdateApPayments`}
//                               className='btn btn-sm btn-outline-theme'
//                               title={t('ViewDetails')}
//                             >
//                               <i className='bi bi-info-circle fa-lg me-1'></i>
//                               تفاصيل
//                             </Link>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan={6} className='text-center py-5 text-muted'>
//                       <div className='py-4'>
//                         <i className='fa fa-inbox fa-3x mb-3 opacity-50'></i>
//                         <h5 className='mb-2'>
//                           {activeFiltersCount > 0 ? t('NoSearchResults') : t('NoPaymentsRegistered')}
//                         </h5>
//                         <p className='text-muted small'>
//                           {activeFiltersCount > 0
//                             ? 'جرب تغيير شروط البحث أو إزالة بعض الفلاتر'
//                             : 'لا توجد سندات دفع مسجلة في النظام'}
//                         </p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </Loading>

//         <CardFooter>
//           <div className='text-theme'>
//             <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
//           </div>
//         </CardFooter>
//       </Card>

//       <DynamicFilter
//         tableKey={TABLE_KEY}
//         fields={fields}
//         show={showFilters}
//         onClose={() => setShowFilters(false)}
//       />
//     </>
//   );
// };

// export default Index;

import { useEffect, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardFooter, CardHeader } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getPagedData, setEndpoint, setFilters } from '@store/DynamicSlice/dynamicTableSlice';
import { DynamicFilter } from '@Helper/DynamicFilter/DynamicFilter';
import { DynamicPagination } from '@Helper/DynamicFilter/DynamicPagination';
import Select from 'react-select';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import { paymentTypeEnum } from './paymentTypeEnum';
import useGetPaymentMethod from '@hooks/Payrolls/use-Get-PaymentMethod';

const TABLE_KEY = 'ApPayments_Index';

const Index = () => {
  const { t, i18n } = useTranslation();

  // ✅ حالة الفلاتر المحلية
  const [supplierFilter, setSupplierFilter] = useState<any>(null);
  const [organizationFilter, setOrganizationFilter] = useState<any>(null);
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [statusFilter, setStatusFilter] = useState<any>(null);
  const [paymentTypeFilter, setPaymentTypeFilter] = useState<any>(null);

  // ✅ NEW: فلتر طريقة الدفع
  const [paymentMethodFilter, setPaymentMethodFilter] = useState<any>(null);

  const [showFilters, setShowFilters] = useState(false);
  const { optionsPaymentMethod } = useGetPaymentMethod();

  const { OperatingUnitOptions } = useGetOperatingUnitWithPermission();
  const { OptionSuppliers } = useGetSuppliersList();

  const dispatch = useAppDispatch();
  const tableState = useAppSelector(state => state.dynamicTable[TABLE_KEY]);
  const data = tableState?.data ?? [];
  const loading = tableState?.loading ?? false;
  const error = tableState?.error ?? null;
  const filters = tableState?.filters ?? [];
  const [activeFiltersCount, setActiveFiltersCount] = useState(0);

  // ✅ تهيئة الجدول
  useEffect(() => {
    dispatch(setEndpoint({ tableKey: TABLE_KEY, endpoint: 'Ap/GetApPaymentsList_Paged' }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  }, [dispatch]);

  // ✅ حساب عدد الفلاتر النشطة
  useEffect(() => {
    setActiveFiltersCount(filters.length);
  }, [filters]);

  // ✅ دالة إنشاء ID فريد للفلتر
  const generateFilterId = () => `filter-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

  // ✅ دالة تطبيق الفلاتر
  const applyFilters = () => {
    const newFilters: any[] = [];

    if (supplierFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'peopleId',
        operator: 0,
        value: supplierFilter.value
      });
    }

    if (organizationFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'organizationId',
        operator: 0,
        value: organizationFilter.value
      });
    }

    if (statusFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'status',
        operator: 0,
        value: statusFilter.value
      });
    }

    if (paymentTypeFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'paymentType',
        operator: 0,
        value: paymentTypeFilter.value
      });
    }

    // ✅ NEW: طريقة الدفع
    if (paymentMethodFilter) {
      newFilters.push({
        id: generateFilterId(),
        field: 'paymentMethodId', // ⚠️ عدّلها إذا عندك اسم مختلف في الـ API/SP
        operator: 0,
        value: paymentMethodFilter.value
      });
    }

    if (dateFrom) {
      newFilters.push({
        id: generateFilterId(),
        field: 'paymentDate',
        operator: 3,
        value: dateFrom
      });
    }

    if (dateTo) {
      newFilters.push({
        id: generateFilterId(),
        field: 'paymentDate',
        operator: 5,
        value: dateTo
      });
    }

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: newFilters }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  // ✅ دالة مسح جميع الفلاتر
  const clearFilters = (): void => {
    setSupplierFilter(null);
    setOrganizationFilter(null);
    setStatusFilter(null);
    setPaymentTypeFilter(null);
    setDateFrom('');
    setDateTo('');

    // ✅ NEW
    setPaymentMethodFilter(null);

    dispatch(setFilters({ tableKey: TABLE_KEY, filters: [] }));
    dispatch(getPagedData({ tableKey: TABLE_KEY }));
  };

  // ✅ خيارات حالة السند
  const statusOptions = [
    { value: 'active', label: t('مكتمل') },
    { value: 'cancelled', label: t('ملغي') }
    // { value: 'posted', label: t('Posted') },
    // { value: 'draft', label: t('Draft') },
    // { value: 'pending', label: t('Pending') }
  ];

  // ✅ خيارات نوع السند
  const paymentTypeOptions = [
    { value: paymentTypeEnum.Standard, label: t('Standard') },
    { value: paymentTypeEnum.PrePayment, label: t('PrePayment') },
    { value: paymentTypeEnum.Refund, label: t('استرداد') },
    { value: paymentTypeEnum.ApplyPrePayment, label: t('تطبيق دفعة مقدمة') },
    { value: paymentTypeEnum.ApplyDebitMemo, label: t('تطبيق إشعار مديــن') }
  ];

  // ✅ حقول Dynamic Filter
  const fields: any = [
    { name: 'no', label: t('التسلسل'), type: 'number' },
    { name: 'code', label: t('VoucherNumber'), type: 'string' },
    { name: 'paymentDate', label: t('Date'), type: 'date' },
    {
      name: 'paymentType',
      label: t('PaymentType'),
      type: 'options',
      options: paymentTypeOptions
    },
    {
      name: 'status',
      label: t('status'),
      type: 'options',
      options: statusOptions
    },
    {
      name: 'postedFlag',
      label: t('PostingStatus'),
      type: 'options',
      options: [
        { value: true, label: t('Posted') },
        { value: false, label: t('NotPosted') }
      ]
    },
    { name: 'peopleId', label: t('Supplier'), type: 'options', options: OptionSuppliers },
    { name: 'organizationId', label: t('OperatingUnit'), type: 'options', options: OperatingUnitOptions },
    { name: 'description', label: t('Description'), type: 'string' },
    { name: 'amount', label: t('Amount'), type: 'number' }
  ];

  // ✅ دالة لتنسيق المبلغ
  const formatAmount = (amount: number) => {
    return new Intl.NumberFormat(i18n.language, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };

  // ✅ دالة للتحقق إذا كان السند ملغياً
  const isCancelled = (status: string) => {
    return status?.toLowerCase() === 'cancelled';
  };

  // ✅ دالة لعرض نوع السند مع أيقونة
  const getPaymentTypeDisplay = (type: string, name: string, isCancelled: boolean) => {
    const baseClass = isCancelled ? 'opacity-60' : '';

    switch (type) {
      case paymentTypeEnum.Standard:
        return (
          <span className={`badge bg-primary ${baseClass}`} title={name}>
            <i className='fas fa-file-invoice-dollar me-1'></i>
            قياسي
          </span>
        );
      case paymentTypeEnum.PrePayment:
        return (
          <span className={`badge bg-success ${baseClass}`} title={name}>
            <i className='fas fa-hand-holding-usd me-1'></i>
            مقدمة
          </span>
        );
      case paymentTypeEnum.Refund:
        return (
          <span className={`badge bg-danger ${baseClass}`} title={name}>
            <i className='fas fa-rotate-left me-1'></i>
            استرداد
          </span>
        );
      case paymentTypeEnum.ApplyPrePayment:
        return (
          <span className={`badge bg-info text-dark ${baseClass}`} title={name}>
            <i className='fas fa-link me-1'></i>
            تطبيق مقدمة
          </span>
        );
      case paymentTypeEnum.ApplyDebitMemo:
        return (
          <span className={`badge bg-warning text-dark ${baseClass}`} title='تطبيق إشعار مدين'>
            <i className='fas fa-file-invoice me-1'></i>
            تطبيق مدين
          </span>
        );
      default:
        return (
          <span className={`badge bg-secondary ${baseClass}`} title={name}>
            <i className='fas fa-question-circle me-1'></i>
            {name}
          </span>
        );
    }
  };

  // ✅ دالة لعرض الحالة مع أيقونة
  const getStatusBadge = (status: string) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return (
          <span className='badge bg-success' title={t('مكتمل')}>
            <i className='fas fa-check-circle me-1'></i>
            مكتمل
          </span>
        );
      case 'cancelled':
        return (
          <span className='badge bg-danger' title={t('ملغي')}>
            <i className='fas fa-times-circle me-1'></i>
            ملغي
          </span>
        );
      case 'posted':
        return (
          <span className='badge bg-primary' title={t('Posted')}>
            <i className='fas fa-paper-plane me-1'></i>
            مرفوع
          </span>
        );
      case 'draft':
        return (
          <span className='badge bg-secondary' title={t('Draft')}>
            <i className='fas fa-edit me-1'></i>
            مسودة
          </span>
        );
      case 'pending':
        return (
          <span className='badge bg-warning text-dark' title={t('Pending')}>
            <i className='fas fa-clock me-1'></i>
            معلق
          </span>
        );
      default:
        return (
          <span className='badge bg-light text-dark' title={status || t('Unknown')}>
            <i className='fas fa-circle me-1'></i>
            {status || 'غير معروف'}
          </span>
        );
    }
  };

  // ✅ دالة لعرض حالة الترحيل
  const getPostedFlagBadge = (flag: boolean, isCancelled: boolean) => {
    const baseClass = isCancelled ? 'opacity-60' : '';

    return flag ? (
      <span className={`badge bg-success ${baseClass}`} title={t('Posted')}>
        <i className='fas fa-check me-1'></i>
        مرحــل
      </span>
    ) : (
      <span className={`badge bg-danger ${baseClass}`} title={t('NotPosted')}>
        <i className='fas fa-times me-1'></i>
        غير مرحل
      </span>
    );
  };

  // ✅ دالة لعرض رقم السند مع تاريخه في عمود واحد
  const renderVoucherWithDate = (code: string, date: string, isCancelled: boolean) => {
    const formattedDate = date.split('T')[0];

    return (
      <div className='d-flex flex-column'>
        <div className='fw-bold'>
          {isCancelled ? (
            <div className='d-flex align-items-center'>
              <span className='text-danger text-decoration-line-through me-2' style={{ letterSpacing: '0.05em' }}>
                {code}
              </span>
              <span className='badge bg-danger badge-sm'>
                <i className='fas fa-ban'></i>
              </span>
            </div>
          ) : (
            <span className='text-theme' style={{ letterSpacing: '0.05em' }}>
              {code}
            </span>
          )}
        </div>
        <small className={`text-muted ${isCancelled ? 'text-decoration-line-through' : ''}`}>
          <i className='fas fa-calendar-alt me-1'></i>
          {formattedDate}
        </small>
      </div>
    );
  };

  // ✅ دالة لعرض المورد مع وحدة التشغيل في عمود واحد
  const renderSupplierWithOrg = (
    supplierName: string,
    orgName: string,
    supplierCode?: string,
    isCancelled: boolean = false
  ) => {
    const textClass = isCancelled ? 'text-decoration-line-through opacity-70' : '';

    return (
      <div className='d-flex flex-column'>
        <div className={`fw-bold ${textClass}`}>{supplierName}</div>
        {supplierCode && (
          <small className={`text-muted ${textClass}`}>
            <i className='fas fa-hashtag me-1'></i>
            {supplierCode}
          </small>
        )}
        <small className={`text-muted mt-1 ${textClass}`}>
          <i className='fas fa-building me-1'></i>
          {orgName}
        </small>
      </div>
    );
  };

  // ✅ دالة لعرض الحالة مع الترحيل في عمود واحد
  const renderStatusWithPosting = (status: string, postedFlag: boolean, isCancelled: boolean) => {
    return (
      <div className='d-flex flex-column align-items-center gap-1'>
        {getStatusBadge(status)}
        {getPostedFlagBadge(postedFlag, isCancelled)}
      </div>
    );
  };

  // ✅ دالة لعرض المبلغ مع الوصف في عمود واحد
  const renderAmountWithDescription = (amount: number, description?: string, isCancelled: boolean = false) => {
    const desc = (description ?? '').trim();
    const amountClass = isCancelled ? 'text-decoration-line-through opacity-70' : 'text-theme';
    const descClass = isCancelled ? 'text-decoration-line-through opacity-60' : '';

    return (
      <div className='d-flex flex-column'>
        <span className={`fw-bold fs-6 ${amountClass}`}>
          {formatAmount(amount)}
          {isCancelled && (
            <span className='ms-2 badge bg-danger badge-sm'>
              <i className='fas fa-ban'></i>
            </span>
          )}
        </span>
        {desc && (
          <small className={`text-muted mt-1 ${descClass}`} title={desc}>
            <i className='fas fa-align-left me-1'></i>
            {desc.length > 40 ? `${desc.substring(0, 40)}...` : desc}
          </small>
        )}
      </div>
    );
  };

  // ✅ دالة للحصول على كلاسات الصف بناءً على حالة السند
  const getRowClasses = (status: string) => {
    if (isCancelled(status)) {
      return 'bg-light bg-opacity-25 border-end border-1 border-danger';
    }
    return '';
  };

  const breadcrumbList = [
    { name: t('Home'), link: ':moduleHome' },
    { name: t('Payments'), link: null }
  ];

  return (
    <>
      <div className='d-flex flex-wrap align-items-center gap-2'>
        <Breadcrumb BreadcrumbList={breadcrumbList} PageName={t('Payments')} />
        <div className='ms-auto'>
          <Link to='AddApPayments' className='btn btn-theme'>
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('NewPayment')}
          </Link>
        </div>
      </div>

      <Card className='mb-4'>
        <CardHeader>
          <div className='row g-2'>
            {/* ✅ فلترة بوحدة التشغيل */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-building'></i>
                </span>
                <Select
                  value={organizationFilter}
                  onChange={setOrganizationFilter}
                  options={OperatingUnitOptions}
                  placeholder={t('اختر وحدة تشغيـل')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                  }}
                />
              </div>
            </div>

            {/* ✅ فلترة بالمورد */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-truck'></i>
                </span>
                <Select
                  value={supplierFilter}
                  onChange={setSupplierFilter}
                  options={OptionSuppliers}
                  placeholder={t('اختر مورد')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                  }}
                />
              </div>
            </div>

            {/* ✅ فلترة بنوع السند */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-file-invoice-dollar'></i>
                </span>
                <Select
                  value={paymentTypeFilter}
                  onChange={setPaymentTypeFilter}
                  options={paymentTypeOptions}
                  placeholder={t('نوع السند')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                  }}
                />
              </div>
            </div>

            {/* ✅ فلترة بالحالة */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-info-circle'></i>
                </span>
                <Select
                  value={statusFilter}
                  onChange={setStatusFilter}
                  options={statusOptions}
                  placeholder={t('الحالة')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                  }}
                />
              </div>
            </div>

            {/* ✅ NEW: فلترة بطريقة الدفع */}
            <div className='col-lg-3'>
              <div className='input-group'>
                <span className='input-group-text fw-bold'>
                  <i className='fas fa-credit-card'></i>
                </span>
                <Select
                  value={paymentMethodFilter}
                  onChange={setPaymentMethodFilter}
                  options={optionsPaymentMethod}
                  placeholder={t('طريقة الدفع')}
                  isClearable
                  isSearchable
                  className='flex-grow-1'
                  classNamePrefix='react-select'
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                  }}
                />
              </div>
            </div>

            {/* ✅ التاريخ من وإلى */}
            <div className='col-lg-6'>
              <div className='input-group'>
                <span className='input-group-text'>
                  <i className='fas fa-calendar-alt text-muted'></i>
                </span>
                <input
                  type='date'
                  className='form-control border-start-0'
                  value={dateFrom}
                  onChange={e => setDateFrom(e.target.value)}
                  placeholder={t('من')}
                />
                <span className='input-group-text'>-</span>
                <input
                  type='date'
                  className='form-control'
                  value={dateTo}
                  onChange={e => setDateTo(e.target.value)}
                  placeholder={t('إلى')}
                />
              </div>
            </div>

            {/* ✅ أزرار التطبيق والمسح */}
            <div className='col-lg-3 text-end'>
              <button
                className='btn btn-outline-secondary me-2'
                type='button'
                onClick={clearFilters}
                title={t('ClearFilters')}
                disabled={activeFiltersCount === 0}
              >
                <i className='fas fa-times fa-fw'></i>
              </button>
              <button
                className='btn btn-theme me-2'
                type='button'
                onClick={applyFilters}
                title={t('ApplyFilters')}
                disabled={
                  !supplierFilter &&
                  !paymentMethodFilter &&
                  !organizationFilter &&
                  !paymentTypeFilter &&
                  !statusFilter &&
                  !dateFrom &&
                  !dateTo
                }
              >
                <i className='fas fa-filter fa-fw'></i>
              </button>
              <button className='btn btn-outline-theme' onClick={() => setShowFilters(true)} title={t('SearchFilters')}>
                <i className='fas fa-sliders-h fa-fw'></i>
              </button>
            </div>
          </div>
        </CardHeader>

        <Loading loading={loading} error={error}>
          <div className='table-responsive'>
            <table className='table table-hover mb-0'>
              <thead className='bg-theme bg-opacity-25 fw-bold'>
                <tr>
                  <th className='small'>رقم السند / التاريخ</th>
                  <th className='small'>نوع السند</th>
                  <th className='small'>المبلغ / الوصف</th>
                  <th className='small'>المورد / وحدة التشغيل</th>
                  <th className='small text-center'>الحالة / الترحيل</th>
                  <th className='small text-center'>الإجراءات</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((item: any) => {
                    const cancelled = isCancelled(item.status);
                    const TypeName = i18n.language === 'en' ? item.paymentTypeName : item.paymentTypeName2;
                    const supplierName = i18n.language === 'en' ? item.peopleName : item.peopleName2;
                    const orgName = i18n.language === 'en' ? item.organizationName : item.organizationName2;

                    return (
                      <tr key={item.id} className={getRowClasses(item.status)}>
                        <td className='align-middle'>
                          {renderVoucherWithDate(item.code, item.paymentDate, cancelled)}
                        </td>
                        <td className='align-middle'>{getPaymentTypeDisplay(item.paymentType, TypeName, cancelled)}</td>
                        <td className='align-middle'>
                          {renderAmountWithDescription(item.amount, item.description, cancelled)}
                        </td>
                        <td className='align-middle'>
                          {renderSupplierWithOrg(supplierName, orgName, item.peopleCode, cancelled)}
                        </td>
                        <td className='align-middle text-center'>
                          {renderStatusWithPosting(item.status, item.postedFlag || false, cancelled)}
                        </td>
                        <td className='align-middle text-end'>
                          <div className='d-flex justify-content-end gap-2'>
                            <Link
                              to={`${item.id}/UpdateApPayments`}
                              className={`btn btn-sm ${cancelled ? 'btn-outline-secondary' : 'btn-outline-theme'}`}
                              title={t('ViewDetails')}
                            >
                              <i className={`bi bi-info-circle fa-lg me-1 ${cancelled ? 'text-muted' : ''}`}></i>
                              {cancelled ? 'عرض' : 'تفاصيل'}
                            </Link>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={6} className='text-center py-5 text-muted'>
                      <div className='py-4'>
                        <i className='fa fa-inbox fa-3x mb-3 opacity-50'></i>
                        <h5 className='mb-2'>
                          {activeFiltersCount > 0 ? t('NoSearchResults') : t('NoPaymentsRegistered')}
                        </h5>
                        <p className='text-muted small'>
                          {activeFiltersCount > 0
                            ? 'جرب تغيير شروط البحث أو إزالة بعض الفلاتر'
                            : 'لا توجد سندات دفع مسجلة في النظام'}
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Loading>

        <CardFooter>
          <div className='text-theme'>
            <DynamicPagination tableKey={TABLE_KEY} maxVisiblePages={3} showItemsPerPage={true} />
          </div>
        </CardFooter>
      </Card>

      <DynamicFilter tableKey={TABLE_KEY} fields={fields} show={showFilters} onClose={() => setShowFilters(false)} />
    </>
  );
};

export default Index;
